export default __webpack_public_path__ + "static/media/Mark-5-HUD-Targeting (Selector Ring).1d2b38cd.jpg";